export default __webpack_public_path__ + "static/media/css.028d45d6.png";